import { BiMultiMapBuilder, BiMultiMapEmpty, BiMultiMapNonEmpty, } from '@rimbu/bimultimap/custom';
import { Reducer } from '@rimbu/stream';
import { isEmptyStreamSourceInstance } from '@rimbu/stream/custom';
export class BiMultiMapContext {
    constructor(typeTag, keyValueMultiMapContext, valueKeyMultiMapContext) {
        this.typeTag = typeTag;
        this.keyValueMultiMapContext = keyValueMultiMapContext;
        this.valueKeyMultiMapContext = valueKeyMultiMapContext;
        this._empty = Object.freeze(new BiMultiMapEmpty(this));
        this.empty = () => {
            return this._empty;
        };
        this.of = (...entries) => {
            return this.from(entries);
        };
        this.from = (...sources) => {
            if (sources.length === 1) {
                const source = sources[0];
                if (source instanceof BiMultiMapNonEmpty && source.context === this)
                    return source;
            }
            let builder = this.builder();
            let i = -1;
            const length = sources.length;
            while (++i < length) {
                const source = sources[i];
                if (isEmptyStreamSourceInstance(source))
                    continue;
                if (builder.isEmpty &&
                    source instanceof BiMultiMapNonEmpty &&
                    source.context === this) {
                    if (i === length - 1)
                        return source;
                    builder = source.toBuilder();
                    continue;
                }
                builder.addEntries(source);
            }
            return builder.build();
        };
        this.builder = () => {
            return new BiMultiMapBuilder(this);
        };
        this.reducer = (source) => {
            return Reducer.create(() => undefined === source
                ? this.builder()
                : this.from(source).toBuilder(), (builder, entry) => {
                builder.add(entry[0], entry[1]);
                return builder;
            }, (builder) => builder.build());
        };
    }
    get _types() {
        return undefined;
    }
    createBuilder(source) {
        return new BiMultiMapBuilder(this, source);
    }
    createNonEmpty(keyValueMultiMap, valueKeyMultiMap) {
        return new BiMultiMapNonEmpty(this, keyValueMultiMap, valueKeyMultiMap);
    }
}
//# sourceMappingURL=context.mjs.map